import { render, staticRenderFns } from "./announcement-display.vue?vue&type=template&id=e79501fc&"
import script from "./announcement-display.vue?vue&type=script&lang=js&"
export * from "./announcement-display.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports